export enum UserSettingsRouteFragment {
  PROFILE = 'profile',
  EMAIL = 'email-and-notifications',
  MEMBERSHIP = 'membership',
  PASSWORD = 'password',
  FINANCIALS = 'financials',
  SECURITY = 'security',
  VERIFICATION = 'verification',
  ACCOUNT = 'account',
  EXPERT_COMMUNITIES = 'expert-communities',
}

export const REDIRECT_MAPPING: Record<UserSettingsRouteFragment, string> = {
  [UserSettingsRouteFragment.PROFILE]: 'ProfileSettings',
  [UserSettingsRouteFragment.EMAIL]: 'EmailSettings',
  [UserSettingsRouteFragment.MEMBERSHIP]: 'MembershipSettings',
  [UserSettingsRouteFragment.PASSWORD]: 'PasswordSettings',
  [UserSettingsRouteFragment.FINANCIALS]: 'PaymentSettings',
  [UserSettingsRouteFragment.SECURITY]: 'AccountSecurity',
  [UserSettingsRouteFragment.VERIFICATION]: 'TrustSettings',
  [UserSettingsRouteFragment.ACCOUNT]: 'AccountSettings',
  [UserSettingsRouteFragment.EXPERT_COMMUNITIES]: 'ExpertCommunities',
};
